module.exports = __webpack_public_path__ + "media/images/tmp/ig0-ec253bc15b19caf5dc60b3243e68af2d.png";